import Vue from 'vue'
import VueRouter from 'vue-router'
import { changeTheme } from '@/utils/index.js' //getProductCode
import service from '@/service'
import store from '@/store'
const originalPush = VueRouter.prototype.push
const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err)
}
Vue.use(VueRouter)

const modules = import.meta.globEager('./*.router.js')

let childRoutes = [],
  customerRouters = [],
  topRouters = []

//添加一级路由
for (let index in modules) {
  modules[index].default.forEach(item => {
    let parent = item.meta?.parent
    if (parent) {
      if (parent === 'main') {
        //子路由
        childRoutes.push(item)
      } else {
        customerRouters.push(item)
      }
    } else {
      topRouters.push(item)
    }
  })
}

const routes = [
  {
    // 首页，落地页
    path: '/',
    name: 'index',
    redirect: '/home',
  },
  {
    // 注册页
    path: '/register',
    name: 'register',
    component: () => import('../views/register/index.vue'),
    meta: { bgGray: true, needLogin: false },
  },
  {
    // 找回密码
    path: '/remember',
    name: 'remember',
    component: () => import('@/views/remember/index.vue'),
    meta: {
      bgGray: true,
      needLogin: false,
    },
  },
  {
    // 修改密码
    path: '/change',
    name: 'change',
    component: () => import('@/views/change/index.vue'),
    meta: {
      bgGray: true,
    },
  },
  {
    // 登录页
    path: '/login',
    name: 'login',
    component: () => import('../views/login/index.vue'),
    meta: {
      needLogin: false,
    },
  },
  {
    // 首页，登录后
    path: '/main',
    name: 'main',
    component: () => import('../views/main.vue'),
    children: [...childRoutes],
  },
  ...topRouters,
]

for (let index in modules) {
  routes.push(...modules[index].default)
}

export function createRouter(base = '/', mode = 'history') {
  const router = new VueRouter({
    mode,
    base,
    routes,
  })
  const processGlobalData = async function() {
    // store.dispatch('user/updateUser', { login: true })
    if (store.getters.userInfo.login === undefined) {
      try {
        let user = await service.queryLoginUserInfo().executeSerial()
        if (user.login) {
          let companyInfo = await service.queryUserCompanyDetail({}).executeSerial()
          user = { ...user, ...companyInfo.baseInfo }
        }
        store.dispatch('user/updateUser', { ...user })
      } catch (error) {
        store.dispatch('user/updateUser', { login: false })
      }
    }
  }
  router.beforeEach(async (to, from, next) => {
    // 设置主题getStorage('theme') ||
    let theme = store.getters.config?.primaryColor || 'default'
    changeTheme(theme)
    //处理全局登录态，及产品列表
    await processGlobalData()

    if (to.fullPath === from.fullPath) {
      next()
      return
    }

    //通过路由配置，来获取对应页面的字典[],给字典赋上默认值[]
    for (const key of to.meta.enum || []) {
      !store.getters.enumData[key] && (store.getters.enumData[key] = [])
    }
    let arr = Object.keys(store.getters.enumData)
    Object.keys(store.getters.enumData).map((key, index) => {
      !store.getters.enumData[key].length && (arr[index] = undefined)
    })
    let params = (to.meta.enum || []).filter(v => !arr.includes(v))
    params.length && store.dispatch('enum/getEnum', params)
    if (store.getters.userInfo.login) {
      if (!store.getters.menu.length) {
        try {
          // let menu = (await service.getProductMenus({}).executeSerial()) || []
          let menu = [
            {
              functionName: '产品首页',
              path: '/home',
              icon: 'fin-icon-home',
            },
            // {
            //   functionName: '我的订单',
            //   path: '/order',
            //   icon: 'fin-icon-transaction',
            // },
            // {
            //   functionName: '我的应收',
            //   path: '/receivable',
            //   icon: 'fin-icon-folder',
            // },
            {
              functionName: '我的融资',
              path: '/finance',
              icon: 'fin-icon-money',
            },
            {
              functionName: '进度查询',
              path: '/process',
              icon: 'fin-icon-document',
            },
            {
              functionName: '企业信息',
              path: '/enterprise',
              icon: 'fin-icon-enterprise',
            },
          ]
          let menus = menu
          if (menus) {
            store.dispatch('system/setMenu', menus)
            childRoutes.forEach(m => {
              if (menus.find(n => n.path === m.path || (n.urlPerm || '').split(',').includes(m.path))) {
                router.addRoute('main', m)
              }
            })
            router.addRoute({
              path: '*',
              redirect: '/',
            })

            next({
              ...to,
              replace: true,
            })
            return
          }
        } catch (error) {
          next()
        }
      }
      if (store.getters.userInfo.loginAccStatus === 'LOGIN_LOCK') {
        if (to.name != 'register') {
          next({ name: 'register' })
        } else {
          next()
        }
      } else {
        //如果已经登录，并且要进入登录页面，则跳转到home页
        if (to.name === 'login') {
          next({ name: 'home-index' })
        } else {
          next()
        }
      }
    } else {
      if (to.meta.needLogin !== false) {
        //需要登录，但是未登录
        window.location.href = `/login?ReturnUrl=${encodeURIComponent(window.location.href)}`
      } else {
        next()
      }
    }
  })

  /**
   * 埋点pv上报
   */
  // router.afterEach((to, from) => {})
  return router
}

const router = createRouter()
export default router

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
}
